import Component from '../interfaces/Component';

export const INITIAL_VALUES: Component = {
    nome: '',
    tipo_componente_id: 0,
    status: true,
    funcionalidade_id: 0

}